// removed by extract-text-webpack-plugin
module.exports = {"icon":"src-components-BoxButton-__BoxButton-module___icon","processed":"src-components-BoxButton-__BoxButton-module___processed"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BoxButton/BoxButton.module.css
// module id = 155
// module chunks = 0